import axios from "axios";
class ApisClient {
  constructor(chatConfig) {
    this.chatConfig = chatConfig;
  }
  _getUri(endpoint, query) {
    let host;
    if (endpoint.includes("/chat/advisor") || endpoint.startsWith("/chat/rest")) {
      host = this.chatConfig.chatProxyHost;
    } else {
      host = this.chatConfig.chatBotHost;
    }
    let uri = host + endpoint;
    const keys = Object.keys(query);
    const values = Object.values(query);
    for (let i = 0; i < keys.length; i++) {
      uri = uri.replace("[" + keys[i] + "]", values[i]);
    }
    return uri;
  }
  _getHeaders(source = false) {
    return {};
  }
  get(endpoint, query, params, headers = {}, signal = null) {
    query = query || {};
    params = params || {};
    const uri = this._getUri(endpoint, query);
    return new Promise((resolve, reject) => {
      axios.get(uri, {
        withCredentials: true,
        params,
        headers,
        signal
      }).then((response) => {
        if (response.data.error) {
          return reject(response.data.error);
        }
        return resolve(
          response.data.data ? response.data.data : response.data
        );
      }).catch((error) => {
        return reject(error);
      });
    });
  }
  post(endpoint, query, params, data, headers = {}, signal = null) {
    query = query || {};
    params = params || {};
    const uri = this._getUri(endpoint, query);
    return new Promise((resolve, reject) => {
      axios.post(uri, data, {
        withCredentials: true,
        params,
        headers,
        signal
      }).then((response) => {
        if (response.data.error) {
          return reject(response.data.error);
        }
        return resolve(
          response.data.data ? response.data.data : response.data
        );
      }).catch((error) => {
        return reject(error);
      });
    });
  }
  put(endpoint, query, params, data, source = false, signal = null) {
    query = query || {};
    params = params || {};
    const uri = this._getUri(endpoint, query, source);
    const headers = this._getHeaders(source);
    return new Promise((resolve, reject) => {
      axios.put(uri, data, {
        withCredentials: true,
        params,
        headers,
        signal
      }).then((response) => {
        if (response.data.error) {
          return reject(response.data.error);
        }
        return resolve(response.data.data);
      }).catch((error) => {
        return reject(error);
      });
    });
  }
  delete(endpoint, query, params, data, source = false, signal = null) {
    query = query || {};
    params = params || {};
    const uri = this._getUri(endpoint, query, source);
    const headers = this._getHeaders(source);
    return new Promise((resolve, reject) => {
      axios.delete(uri, {
        withCredentials: true,
        params,
        headers,
        signal
      }).then((response) => {
        if (response.data.error) {
          return reject(response.data.error);
        }
        return resolve(response.data.data);
      }).catch((error) => {
        return reject(error);
      });
    });
  }
  // Method to create parcel claim case
  createParcelClaim(claimData) {
    const apisBaseUrl = this.chatConfig.apisBaseUrl || "http://localhost:8030";
    return new Promise((resolve, reject) => {
      const apisClient = axios.create({
        baseURL: apisBaseUrl,
        withCredentials: true,
        transformResponse: axios.defaults.transformResponse.concat(
          (params) => params.data || params
        )
      });
      apisClient.post("/parcels/case/create", claimData).then((response) => {
        if (response.data.error) {
          return reject(response.data.error);
        }
        return resolve(
          response.data.data ? response.data.data : response.data
        );
      }).catch((error) => {
        return reject(error);
      });
    });
  }
}
export {
  ApisClient as default
};
//# sourceMappingURL=api.js.map
